module.exports = __webpack_public_path__ + "static/img/08.286c1a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/08.jpg
// module id = cZs5
// module chunks = 0